document.addEventListener('DOMContentLoaded', () => {
    const cookieBanner = document.querySelector('#sliding-popup');
    const cookieAccepted = localStorage.getItem('cookies-accepted');

    if (cookieAccepted != 1) {
        cookieBanner.classList.add('slide-up');

        const cookieCloseButton = document.querySelector('#close-button');
        
        cookieCloseButton.addEventListener('click', () => {
            cookieBanner.classList.remove('slide-up');
            localStorage.setItem('cookies-accepted', 1);
        });
    }
    
});
